
var productList={};
var currProInfo={};
var filterBrogues=false;

const calculatePrice = (price) => {
  const rate = Shopify?.currency?.rate ?? 1;
  const convertedMoney = price * 100 * rate;
  return displayMoney(convertedMoney);
}

const displayMoney = (amount) => {
  if(Shopify?.formatMoney)
  return Shopify.formatMoney(amount, `${window.shopifyCurrency ?? '$'}{{amount}}`);
 return (amount / 100).toLocaleString('en-US', {
   style: 'currency',
   currency: 'USD',
 });
}

jQuery(document).ready(function () { 

    jQuery(".loading").css("top","50%");
    jQuery(".loading1").css("top","50%");  
  
     if(sessionStorage.getItem("customizeThrough") == "customizeBtn")
       {
          
         jQuery(".loading").show();
         jQuery(".loading1").show(); 
         jQuery("header").css("opacity", "0");
         jQuery(".tool-sec").css("opacity", "0");
         console.log("in customize thro")
       }

       var prodStr = sessionStorage.getItem("product");
       var product;
       if(prodStr) {
        product = JSON.parse(prodStr);
        sessionStorage.removeItem("product");
       }
       
       if(product) {
         loadProduct(null, product);
       }
       else {
        jQuery.ajax({ 
          url: basePath + "product-list", 
          success: function (msg) {
            
              productList = JSON.parse(msg);
            
              loadProductList();
            
     
              jQuery(document).trigger("mouseup");
    
         // setTimeout(function () {
               jQuery(".loading").hide();
               jQuery("header").css("opacity", "1");
               jQuery(".tool-sec").css("opacity", "1");
               jQuery(".tool-img").css("opacity", "1");
          }
      });
    
    jQuery("#productListLink").click(function(){
    
       jQuery("#shoes-container").hide();
       jQuery("#shoes-list").show();
       //jQuery("meta[name='viewport']").hide();
       jQuery("#customize-tool").removeClass("customize-tool-main");
      
        jQuery('#myCustomerAccount').hide(); 
      
    
    });
    
    
       //check login
    
       checkLogin();
       //end
       }
  
    


});



function checkLogin()
{

    var custId = sessionStorage.getItem("customer_id");
     
     if(custId != "" && custId)
     {
       jQuery("#login_url").hide();
       jQuery("#myaccount_url").show();
       jQuery("#logout_url").show();
       
      
     }else{
     
       jQuery("#login_url").show();
       jQuery("#myaccount_url").hide();
       jQuery("#logout_url").hide();
     }

}

function filterCollection(parentId){
  if(parentId)
  {
    jQuery(".product-holder li[parent="+parentId+"]").show();
  }else{
   jQuery(".product-holder li").show();
  }
}

function changeMenuImages(isBrogues){

  var hasBrogueElements = $(".product-holder li[broguesImg!='false']:visible");

  var attrImgName = isBrogues ? 'broguesImg' : 'defaultImg';

  jQuery.each(hasBrogueElements, function( index, element ) {
    var imgSrc = $(element).attr(attrImgName);
    $(element).find('img').attr('src', imgSrc);
  });
}

function changeProdCat(actObj)
{
  

  var parentId = jQuery("#prodCategory option:selected").attr("id");
  filterBrogues = jQuery("#broguesFilter").is(":checked");
  jQuery(".product-holder li").hide(); 

  filterCollection(parentId);
  if(filterBrogues){
    var filteredElements = $(".product-holder li[broguesImg='false']:visible");
    filteredElements.hide();
    jQuery(".custom-slider").text("ON");
    jQuery(".custom-slider").css("justify-content", "flex-start");
  }else{
    jQuery(".custom-slider").text("OFF");
    jQuery(".custom-slider").css("justify-content", "flex-end");
  }
  changeMenuImages(filterBrogues);

  //jQuery("#prodCategory option[data-id=0]").remove();

}

function loadProductList() 
{
 
   jQuery(".product-holder ul").html("");
  
   var visibleProds = [];
   var visibleProdIds = [
    { id: '460990265', value: 1 },
    { id: '460991377', value: 2 },
    { id: '2197325185', value: 3 },
    { id: '4609724981', value: 4 },
    { id: '7632957377', value: 6 },
    { id: '1267259905', value: 5 },
    { id: '1463683329', value: 7 },
    { id: '4221337537', value: 8 },
    { id: '1465578305', value: 9 },
    { id: '6050500865', value: 10 },
    { id: '5418704577', value: 11 },
    { id: '1464803201', value: 12 },
    { id: '6566222337', value: 13 },
    { id: '1357580927062', value: 14 },
    { id: '5418812417', value: 15 },
    { id: '6567772417', value: 16 },
    { id: '1358467629142', value: 17 },
    { id: '1358334558294', value: 18 },
    { id: '1362437832790', value: 19 },
    { id: '1464712769', value: 20 },
    { id: '461014449', value: 21 },
    { id: '1464581697', value: 22 },
    { id: '1358365491286', value: 23 },
    { id: '1464360513', value: 24 },
    { id: '1464360553', value: 25 },
    { id: '1358365491287', value: 26 },
    { id: '1464360529', value: 27 },
    { id: '4219340353', value: 28 },
    { id: '4219595649', value: 29 },
    { id: '9987925889', value: 30 },
    { id: '552167276574', value: 31 },
    { id: '2198116929', value: 32 },
    { id: '462675009', value: 33 },
    { id: '1467857665', value: 34 },
    { id: '5419162049', value: 35 },
  ];  

   var brogueProds = productList.arr_brogues_prods.map(listEl => listEl.product_id);
   for(var prod in productList.arr_product_list) 
   {
      var image = (productList.arr_product_list[prod]["product_image"])?productList.arr_product_list[prod]["product_image"]:"http://cdn.shopify.com/s/files/1/0805/5969/t/2/assets/image-not-found.jpeg";////cdn.shopify.com/s/files/1/0805/5969/t/2/assets/image-not-found.jpeg
      var name = productList.arr_product_list[prod]["title"].split("-");//is_customizable
      var designImage = productList.arr_product_list[prod]["product_customize_image"];//is_customizable
     
      //9977652737 - nassua -2 
      //460972461 - oddity -1 
     
      //548490182686 - dup bog -2 
      //547124019230 - dup sav -2 
     
     //560914563102 - dup odit -2 
     //560913252382 - dup Arsenal -2 
     
     //560915906590 - dup Nassua -2 
     //560918298654 -dup Saratoga -2 
     
     //5418780353 -dup saratogga -2
     
     //morgan duplicate -1373464887382
     
     //p3
     //1467857665 -Armada
     
     //p3 end
       // console.log(productList.arr_product_list[prod]["product_id"])
       
        if(designImage)
        { 
          var found = visibleProdIds.find(function(p) {
            return p.id === productList.arr_product_list[prod]["product_id"];
          });

         if(found) {
          visibleProds.push(productList.arr_product_list[prod]);
        }
      }
    }
    
    // sort products
    var visibleProdsSorted = visibleProds.sort(function(a, b) {
      var found1 = visibleProdIds.find(function(p) {
        return p.id === a["product_id"];
      });
      var found2 = visibleProdIds.find(function(p) {
        return p.id === b["product_id"];
      });
      return found1.value - found2.value;
    });

    // append selected products in order
    visibleProdsSorted.forEach(function(p){
      var name = p["title"].split("-");

      var broguesImg = 'false';
      if(brogueProds.includes(p["product_id"])){
        broguesImg = basePath+"media/backend/img/product-customize-images-brogues/"+p["product_id"] + ".jpg";
      }
      var designImage = p["product_customize_image"];
      jQuery(".product-holder ul").append('<li parent="'+p["category_parent_id"]+'"'
      +
      'broguesImg="' + broguesImg + '"'
      +
      'defaultImg="'+basePath+"media/backend/img/product-customize-images/"+designImage+'"'
      +
      ' onclick="loadProduct(this);" product_id="'+p["product_id"]+'" is_customizable="'+p["is_customizable"]+'"><div class="prod-cover prod-caption">  <div class="prod-img">  <a href="javascript:void(0)" ><img src="'+basePath+"media/backend/img/product-customize-images/"+designImage+'" alt="product"></a></div><div class="prod-caption">     <div class="prod-nm"><a href="javascript:void(0)"><div class="productName"><span class="prodName">' + name[0] + '</span> - <span class="prodCat">' + name[1] +'</span></div></a></div><div class="prod-cost"><p><span class="productPrice">'+calculatePrice(p["price"])+'</span></p></div></div> </div>                            </div>                                        </li>');
    });
   
    var prodId = sessionStorage.getItem("product_id"); 
  
    if(prodId != "")
    {
       loaderFlag = true;
      console.log('prod id ==1356909903958' + prodId)
      console.log('in prod id not null')
     jQuery(".product-holder [product_id="+prodId+"]").trigger("click");
     sessionStorage.setItem("product_id","");
      
    } 
  
   //loadCategory
   jQuery("#prodCategory").html(""); 
   
   jQuery("#prodCategory").append('<option data-id="0">ALL STYLES</option>'); 
   for(var prod in productList.arr_product_categories)
   {
       jQuery("#prodCategory").append('<option id="'+productList.arr_product_categories[prod]["category_id"]+'" >'+(productList.arr_product_categories[prod]["category_name"]).toUpperCase()+'</option>');
    
   }
  
  if(!loaderFlag){
    
     setTimeout(function(){ 
     // alert(1);
           jQuery(".loading").hide();
           jQuery("body").css("opacity","1");  
           
           jQuery("header").css("opacity", "1");
           jQuery(".tool-sec").css("opacity", "1");
           jQuery(".tool-img").css("opacity", "1");
   
      },300);
  }
  
       
  
  /*else {
  
    jQuery(".loading").show();
    jQuery(".loading1").show(); 
    jQuery("header").css("opacity", "0");
    jQuery(".tool-sec").css("opacity", "0");
    
  }*/

}

function checkBrogues() {
  setTimeout(() => {  
  jQuery("#decorations_20 a").click();
  setTimeout(() => {
    jQuery("#part_17 .attr_list_name").click();
  }, 350);
    if(jQuery("input[name='brouge']").prop("checked") === false){
      jQuery("input[name='brouge']").click();
    }
    setTimeout(() => {
      if(!jQuery("input[name='brouge2']").prop("checked") === false){
        jQuery("input[name='brouge2']").click();
      }
    }, 250);
    if(jQuery("input[name='perforation']").prop("checked") === false){
      jQuery("input[name='perforation']").click();
    }
    setTimeout(() => {
      if(jQuery("input[name='perforation2']").prop("checked") === false){
        jQuery("input[name='perforation2']").click();
      }
    }, 250);
  }, 2500)
}

function loadProduct(actObj, product)
{
  // console.log('in loadprod:', actObj);
   //loaderFlag = false; 
 // var productId = jQuery(actObj).attr("product_id"); 
  
  if(actObj) {
    mainProductId = jQuery(actObj).attr("product_id");//jQuery('#product_id').val();
    var customize = jQuery(actObj).attr("is_customizable");
    if(customize == "No")   {
      alert("This shoe is not available for customization.")
      return false;
    }

    currProInfo["name"]=jQuery(actObj).find(".prodName").text();
    currProInfo["cat"]=jQuery(actObj).find(".prodCat").text();
    currProInfo["price"]=jQuery(actObj).find(".productPrice").text();
  }
  else {
    mainProductId = product.id;
    currProInfo["name"] = product.title;
    currProInfo["cat"] = product.cat;
    currProInfo["price"] = displayMoney(product.price);
  }  
    
    loaderFlag = true;
    
     jQuery("#shoes-container").show(); 
     jQuery("#shoes-list").hide();
    //jQuery("meta[name='viewport']").show();
  
     jQuery("#customize-tool").addClass("customize-tool-main");
  

    
     jQuery(".loading").show(); 
     jQuery(".loading1").show();
     jQuery(".loading-text").show();

     jQuery("header").css("opacity", "0");
     jQuery(".tool-sec").css("opacity", "0");
  
    
    // jQuery("body").css("opacity","0");
  
     //for responsive start/  
  
  jQuery("body").removeClass("bogSara").removeClass("arsenal-cust");
   /*
  const arsenalIds = [
    "1358334558294",
    "1358365491286",
    "1358365491287",
    "5419162049",
    "9987925889",
    "560914563102",
    "1467857665",
    "4219340353",
    "1356883951702",
    "1356909903958",
    "462675009",
    "2198116929",
    "1464360513",
    "1464360529",
    "1464712769",
    "461014449",
    "1464581697",
    "1464360553",
    "4609724981",
    "552167276574",
    "4221337537"
  ];
  if( arsenalIds.includes(mainProductId) ){   
    */
        jQuery("body").addClass("arsenal-cust");
        /*
  }else{
     jQuery("body").addClass("bogSara"); 
  }
  */
  //responsive end/
  
  
    
    
    
  
    jQuery.ajax({
      
        url: basePath + siteToolUrl+"/get-product-data/" + mainProductId,
        success: function (msg) {
          
            

            allProductData = JSON.parse(msg);

            loadProductAttributes(); 
            
          
           jQuery.ajax({
              url: basePath + siteToolUrl+"/get-product-hover-data/" + mainProductId,
             success: function (msg) {
               
               
                 productViews = JSON.parse(msg);
               
                 loadProductViews(); 
               
                //check of deco of res pros
                 handleDecoration(); 
               
               
                //check Brogues if filterd is checked
                if(filterBrogues){
                  checkBrogues();
                }
             }
             
           }); 

            
        }
    });

  
  
}

document
  .querySelector('#broguesFilter')
  .addEventListener('change', changeProdCat, { passive: false });
